import React from 'react';

import './styles.scss';

export const missingSecureBrowserBannerText =
  'LockDown Browser has not been installed on this device. Please contact your teacher.';

const MissingSecureBrowserBanner = () => (
  <div className="secure-browser-banner-missing">
    {missingSecureBrowserBannerText}
  </div>
);

export default MissingSecureBrowserBanner;
